/**
 * @generated SignedSource<<a28a6d4ece37010a1b3dc61b788601fc>>
 * @relayHash c4dbb1e53daef1b7c8f169a3f50616ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f

import type { ConcreteRequest } from 'relay-runtime';
export type PersonalizedTemplatesV2AllTemplatesQuery$variables = Record<PropertyKey, never>;
export type PersonalizedTemplatesV2AllTemplatesQuery$data = {
  readonly allTemplates: {
    readonly nodes: ReadonlyArray<{
      readonly blueprintModuleCompleteKey: string | null;
      readonly contentBlueprintId: string | null;
      readonly itemModuleCompleteKey: string | null;
      readonly name: string | null;
      readonly templateId: string | null;
    } | null> | null;
  } | null;
};
export type PersonalizedTemplatesV2AllTemplatesQuery = {
  response: PersonalizedTemplatesV2AllTemplatesQuery$data;
  variables: PersonalizedTemplatesV2AllTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "usePersonalSpace",
        "value": true
      }
    ],
    "concreteType": "PaginatedTemplateInfoList",
    "kind": "LinkedField",
    "name": "allTemplates",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "templateId"
          },
          {
            "kind": "ScalarField",
            "name": "contentBlueprintId"
          },
          {
            "kind": "ScalarField",
            "name": "blueprintModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "itemModuleCompleteKey"
          },
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ],
    "storageKey": "allTemplates(usePersonalSpace:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "PersonalizedTemplatesV2AllTemplatesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PersonalizedTemplatesV2AllTemplatesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c4dbb1e53daef1b7c8f169a3f50616ce",
    "id": "83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f",
    "metadata": {},
    "name": "PersonalizedTemplatesV2AllTemplatesQuery",
    "operationKind": "query",
    "text": "query PersonalizedTemplatesV2AllTemplatesQuery{allTemplates(usePersonalSpace:true){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,name}}}"
  }
};
})();

(node as any).hash = "f89ae5ce759533fd2a0812719d0966df";

export default node;
